import { createSearchWithCustomPropsAsyncFn } from '@common/search.services';
import { IListResponse, IPagedResultsV1 } from '@gcl/react-core';
import { envConfigs } from '@config/envConfigs';
import { apiServerPost } from '@common/axios.services';
import { IAnnouncementSearchResult } from './announcement.models';

export const apiRoutes = {
  announcementSearch: '/Announcements/Search',
  announcementNonExpired: '/Announcements/NonExpired',
};

export const searchAnnouncementAsync = createSearchWithCustomPropsAsyncFn<
  {},
  IPagedResultsV1<IAnnouncementSearchResult>
>(apiRoutes.announcementSearch);

export const postAnnouncementNonExpiredAsync = async (): Promise<IListResponse<number>> => {
  const result = await apiServerPost<IListResponse<number>>(
    `${envConfigs.apiBaseUrl}${apiRoutes.announcementNonExpired}`,
  );
  return result.data;
};
